import React, { useState, useEffect } from "react";
import Select from "react-select";
import { FiHeart, FiMapPin } from "react-icons/fi";
import axios from "axios";
import { baseurl } from "../../baseurl";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { useCallback } from "react";
import NavigateHome from "../../component/utils/NavigateHome";
import PageCount from "../../component/utils/PageCount";
import FooterTwo from "../../component/FooterTwo";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  customClass: { popup: "swal2-toast-custom" },
});

function PartnerPreferences() {
  const [formData, setFormData] = useState({
    ageRange: "",
    heightRange: "",
    maritalStatus: "",
    education: [],
    occupation: [],
    religion: "",
    sect: "",
    motherTongue: "",
    locationPreference: "",
    eatingHabits: "",
    drinkingHabits: "",
    smokingHabits: "",
    familyType: "",
    partnerPersonality: [],
    aboutPartner: "",
  });
const navigate = useNavigate();


const [locationOptions, setLocationOptions] = useState([]);
const [loadingLocation, setLoadingLocation] = useState(false);

const fetchLocation = async (query) => {
  if (!query) return;

  setLoadingLocation(true);

  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${query}&addressdetails=1`,
      { headers: { "User-Agent": "soulsathi-app" } }
    );

    const data = await res.json();

    const locList = data.slice(0, 10).map((item) => ({
      label: item.display_name,
      value: item.display_name,
      city: item.address.city || item.address.town || item.address.village,
      state: item.address.state,
      country: item.address.country,
      lat: item.lat,
      lon: item.lon,
    }));

    setLocationOptions(locList);
  } catch (error) {
    console.log("Location API Error:", error);
  }

  setLoadingLocation(false);
};

// Debounce to reduce API calls
const debouncedFetchLocation = useCallback(debounce(fetchLocation, 400), []);
  // OPTIONS LISTS ------------------------------

  const heightOptions = [
    { value: "4ft-0in", label: "4'0\"" },
    { value: "4ft-1in", label: "4'1\"" },
    { value: "4ft-2in", label: "4'2\"" },
    { value: "4ft-3in", label: "4'3\"" },
    { value: "4ft-4in", label: "4'4\"" },
    { value: "4ft-5in", label: "4'5\"" },
    { value: "4ft-6in", label: "4'6\"" },
    { value: "4ft-7in", label: "4'7\"" },
    { value: "4ft-8in", label: "4'8\"" },
    { value: "4ft-9in", label: "4'9\"" },
    { value: "4ft-10in", label: "4'10\"" },
    { value: "4ft-11in", label: "4'11\"" },
    { value: "5ft-0in", label: "5'0\"" },
    { value: "5ft-1in", label: "5'1\"" },
    { value: "5ft-2in", label: "5'2\"" },
    { value: "5ft-3in", label: "5'3\"" },
    { value: "5ft-4in", label: "5'4\"" },
    { value: "5ft-5in", label: "5'5\"" },
    { value: "5ft-6in", label: "5'6\"" },
    { value: "5ft-7in", label: "5'7\"" },
    { value: "5ft-8in", label: "5'8\"" },
    { value: "5ft-9in", label: "5'9\"" },
    { value: "5ft-10in", label: "5'10\"" },
    { value: "5ft-11in", label: "5'11\"" },
    { value: "6ft-0in", label: "6'0\"" },
    { value: "6ft-1in", label: "6'1\"" },
    { value: "6ft-2in", label: "6'2\"" },
  ];

  const ageOptions = [
    { value: "18-25", label: "18 - 25 years" },
    { value: "26-30", label: "26 - 30 years" },
    { value: "31-35", label: "31 - 35 years" },
    { value: "36-40", label: "36 - 40 years" },
    { value: "40+", label: "Above 40 years" },
  ];

  const maritalStatusOptions = [
    { value: "never-married", label: "Never Married" },
    { value: "divorced", label: "Divorced" },
    { value: "widowed", label: "Widowed" },
    { value: "separated", label: "Separated" },
  ];

  const educationOptions = [
    { value: "12th", label: "12th / High School" },
    { value: "diploma", label: "Diploma" },
    { value: "graduate", label: "Graduate" },
    { value: "postgraduate", label: "Post Graduate" },
    { value: "phd", label: "Doctorate (PhD)" },
    { value: "professional", label: "Professional Course (CA/CS/MBA)" },
  ];

  const occupationOptions = [
    { value: "it", label: "IT / Software" },
    { value: "doctor", label: "Doctor / Medical" },
    { value: "engineer", label: "Engineer" },
    { value: "teacher", label: "Teacher / Professor" },
    { value: "govt", label: "Government Job" },
    { value: "business", label: "Business / Entrepreneur" },
    { value: "finance", label: "Banking / Finance" },
    { value: "creative", label: "Creative / Media" },
    { value: "other", label: "Other Profession" },
  ];

  const religionOptions = [
    { value: "hindu", label: "Hindu" },
    { value: "muslim", label: "Muslim" },
    { value: "christian", label: "Christian" },
    { value: "sikh", label: "Sikh" },
    { value: "jain", label: "Jain" },
    { value: "buddhist", label: "Buddhist" },
    { value: "any", label: "No Preference" },
  ];

  const sectOptions = [
    { value: "general", label: "General" },
    { value: "sunni", label: "Sunni" },
    { value: "shia", label: "Shia" },
    { value: "other", label: "Other" },
  ];

  const sectMap = {
  hindu: [
    { value: "general", label: "General" },
    { value: "brahmin", label: "Brahmin" },
    { value: "kshatriya", label: "Kshatriya" },
    { value: "vaishya", label: "Vaishya" },
    { value: "shudra", label: "Shudra" },
  ],
  muslim: [
    { value: "sunni", label: "Sunni" },
    { value: "shia", label: "Shia" },
    { value: "bohra", label: "Dawoodi Bohra" },
    { value: "ismaili", label: "Ismaili" },
    { value: "ahmadiyya", label: "Ahmadiyya" },
    { value: "general", label: "General" },
  ],
  christian: [
    { value: "catholic", label: "Catholic" },
    { value: "protestant", label: "Protestant" },
    { value: "orthodox", label: "Orthodox" },
    { value: "other", label: "Other" },
  ],
  sikh: [
    { value: "jat", label: "Jat Sikh" },
    { value: "ramgarhia", label: "Ramgarhia" },
    { value: "mazhabi", label: "Mazhabi" },
    { value: "other", label: "Other" },
  ],
  jain: [{ value: "digambar", label: "Digambar" }, { value: "shwetambar", label: "Shwetambar" }],
  buddhist: [
    { value: "theravada", label: "Theravada" },
    { value: "mahayana", label: "Mahayana" },
    { value: "other", label: "Other" },
  ],
  any: [{ value: "any", label: "No Preference" }],
};

const sectOptionsForSelectedReligion = sectMap[formData.religion] || [{ value: "other", label: "Other" }];


  const languageOptions = [
    { value: "hindi", label: "Hindi" },
    { value: "english", label: "English" },
    { value: "marathi", label: "Marathi" },
    { value: "gujarati", label: "Gujarati" },
    { value: "punjabi", label: "Punjabi" },
    { value: "bangla", label: "Bengali" },
    { value: "tamil", label: "Tamil" },
    { value: "telugu", label: "Telugu" },
    { value: "any", label: "No Preference" },
  ];

  const habits = [
    { value: "no", label: "No" },
    { value: "occasionally", label: "Occasionally" },
    { value: "yes", label: "Yes" },
  ];

  const familyTypeOptions = [
    { value: "nuclear", label: "Nuclear Family" },
    { value: "joint", label: "Joint Family" },
    { value: "no-pref", label: "No Preference" },
  ];

  const personalityOptions = [
    { value: "calm", label: "Calm & Understanding" },
    { value: "outgoing", label: "Outgoing & Social" },
    { value: "ambitious", label: "Ambitious" },
    { value: "family-oriented", label: "Family-Oriented" },
    { value: "adventurous", label: "Adventurous" },
    { value: "kind", label: "Kind & Caring" },
  ];

  // Update any field ------------------
  const handleSelectChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  // FETCH EXISTING PREFS -----------------------
  useEffect(() => {
    const fetchPartnerPref = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const res = await axios.get(`${baseurl}getPartnerPreferences`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        console.log("Partner Pref Response:", res.data);

        const data = res.data.partner_preferences;
        if (!data) return;

        setFormData({
          ageRange: data.age_range || "",
          heightRange: data.height_range || "",
          maritalStatus: data.marital_status || "",
          religion: data.religion || "",
          sect: data.sect || "",
          motherTongue: data.mother_tongue || "",
          education: data.education || [],
          occupation: data.occupation || [],
          locationPreference: data.location_preference || "",
          eatingHabits: data.eating_habits || "",
          drinkingHabits: data.drinking_habits || "",
          smokingHabits: data.smoking_habits || "",
          familyType: data.family_type || "",
          partnerPersonality: data.partner_personality || [],
          aboutPartner: data.about_partner || "",
        });
      } catch (error) {
        console.error("Error loading preferences:", error);
      }
    };

    fetchPartnerPref();
  }, []);

  // SAVE PREFS ---------------------------
const handleSubmit = async (e) => {
  e.preventDefault();

  const token = localStorage.getItem("token");
  if (!token) {
    Toast.fire({ icon: "error", title: "Please login again!" });
    return;
  }

  const payload = {
    age_range: formData.ageRange,
    height_range: formData.heightRange,
    marital_status: formData.maritalStatus,
    religion: formData.religion,
    sect: formData.sect,
    mother_tongue: formData.motherTongue,
    education: formData.education,
    occupation: formData.occupation,
    partner_personality: formData.partnerPersonality,
    location_preference: formData.locationPreference,
    eating_habits: formData.eatingHabits,
    drinking_habits: formData.drinkingHabits,
    smoking_habits: formData.smokingHabits,
    family_type: formData.familyType,
    about_partner: formData.aboutPartner,
  };

  try {
    const res = await axios.post(
      `${baseurl}savePartnerPreferences`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    Toast.fire({
      icon: "success",
      title: "Partner preferences saved successfully!",
    });

    console.log("Final Partner Preference Saved:", res.data);

    // 👉 Navigate after success
    setTimeout(() => {
      navigate("/profile-images");
    }, 700);

  } catch (err) {
    console.error("Saving Error:", err);
    Toast.fire({
      icon: "error",
      title: err?.response?.data?.error || "Failed to save",
    });
  }
};


  // GET SELECTED VALUE (Single)
  const getSelected = (options, value) =>
    options.find((opt) => opt.value === value) || null;

  // GET MULTI SELECT VALUE
  const getMultiSelected = (options, valuesArr) =>
    options.filter((opt) => valuesArr?.includes(opt.value));

  return (

    <>
    <section className="partner-pref-section">
      <PageCount pageName = {"Partner Prefernce"}/>
      <NavigateHome/>
      <div className="partner-pref-container">
        <div className="text-center mb-4">
          <FiHeart className="header-icon" />
          <h2 className="main-title">Build Your Perfect Match Profile ❤️</h2>
          <p className="subtitle">Tell us what kind of partner you are truly looking for…</p>
        </div>

        <form onSubmit={handleSubmit} className="partner-pref-form">

          {/* BASIC PREFS */}
          <div className="pref-section-box">
            <div className="row g-3">

              <div className="col-md-6">
                <label>Preferred Age Range</label>
                <Select
                  options={ageOptions}  classNamePrefix="talaash-select"
                  value={getSelected(ageOptions, formData.ageRange)}
                  onChange={(opt) => handleSelectChange("ageRange", opt?.value)}
                />
              </div>

              <div className="col-md-6">
                <label>Preferred Height</label>
                <Select
                  options={heightOptions}  classNamePrefix="talaash-select"
                  value={getSelected(heightOptions, formData.heightRange)}
                  onChange={(opt) => handleSelectChange("heightRange", opt?.value)}
                />
              </div>

              <div className="col-md-6">
                <label>Marital Status</label>
                <Select
                  options={maritalStatusOptions}  classNamePrefix="talaash-select"
                  value={getSelected(maritalStatusOptions, formData.maritalStatus)}
                  onChange={(opt) => handleSelectChange("maritalStatus", opt?.value)}
                />
              </div>


               <div className="col-md-6">
                <label>Education Level</label>
                <Select
                  isMulti
                  options={educationOptions}  classNamePrefix="talaash-select"
                  value={getMultiSelected(educationOptions, formData.education)}
                  onChange={(opt) => handleSelectChange("education", opt.map(o => o.value))}
                />
              </div>

              <div className="col-md-6">
                <label>Preferred Profession</label>
                <Select
                  isMulti  classNamePrefix="talaash-select"
                  options={occupationOptions}
                  value={getMultiSelected(occupationOptions, formData.occupation)}
                  onChange={(opt) => handleSelectChange("occupation", opt.map(o => o.value))}
                />
              </div>

 <div className="col-md-6">
                <label>Religion</label>
                <Select
                  options={religionOptions}  classNamePrefix="talaash-select"
                  value={getSelected(religionOptions, formData.religion)}
                  onChange={(opt) => handleSelectChange("religion", opt?.value)}
                />
              </div>

              <div className="col-md-6">
  <label>Sect</label>
  <Select
    options={sectOptionsForSelectedReligion}  classNamePrefix="talaash-select"
    value={getSelected(sectOptionsForSelectedReligion, formData.sect)}
    onChange={(opt) => handleSelectChange("sect", opt?.value)}
    isDisabled={!formData.religion || formData.religion === "any"}
  />
</div>

              <div className="col-md-6">
                <label>Mother Tongue</label>
                <Select
                  options={languageOptions}  classNamePrefix="talaash-select"
                  value={getSelected(languageOptions, formData.motherTongue)}
                  onChange={(opt) => handleSelectChange("motherTongue", opt?.value)}
                />
              </div>

             <div className="col-md-12">
  <label>Preferred Location</label>
  <Select
    options={locationOptions}
    placeholder="Search location" 
    isLoading={loadingLocation}
    value={
      formData.locationPreference
        ? { label: formData.locationPreference, value: formData.locationPreference }
        : null
    }
    onInputChange={(inputValue) => {
      if (inputValue.length >= 2) {
        debouncedFetchLocation(inputValue);
      }
    }}
    onChange={(selected) => {
      setFormData({
        ...formData,
        locationPreference: selected?.label || "",
      });
    }}
     classNamePrefix="talaash-select"
    components={{
      DropdownIndicator: () => (
        <FiMapPin size={18} style={{ marginRight: "8px", color: "#555" }} />
      ),
      IndicatorSeparator: () => null,
    }}
  />
</div>


              <div className="col-md-6">
                <label>Eating Habits</label>
                <Select
                  options={[
                    { value: "veg", label: "Vegetarian" },
                    { value: "nonveg", label: "Non-Vegetarian" },
                    { value: "eggetarian", label: "Eggetarian" },
                    { value: "vegan", label: "Vegan" },
                    { value: "any", label: "No Preference" },
                  ]}
                  value={getSelected(
                    [
                      { value: "veg", label: "Vegetarian" },
                      { value: "nonveg", label: "Non-Vegetarian" },
                      { value: "eggetarian", label: "Eggetarian" },
                      { value: "vegan", label: "Vegan" },
                      { value: "any", label: "No Preference" },
                    ],
                    formData.eatingHabits
                  )}  classNamePrefix="talaash-select"
                  onChange={(opt) => handleSelectChange("eatingHabits", opt?.value)}
                />
              </div>

              <div className="col-md-6">
                <label>Drinking Habits</label>
                <Select
                  options={habits}  classNamePrefix="talaash-select"
                  value={getSelected(habits, formData.drinkingHabits)}
                  onChange={(opt) => handleSelectChange("drinkingHabits", opt?.value)}
                />
              </div>

              <div className="col-md-6">
                <label>Smoking Habits</label>
                <Select
                  options={habits}  classNamePrefix="talaash-select"
                  value={getSelected(habits, formData.smokingHabits)}
                  onChange={(opt) => handleSelectChange("smokingHabits", opt?.value)}
                />
              </div>

              {/* <div className="col-md-6">
                <label>Preferred Family Type</label>
                <Select
                  options={familyTypeOptions} classNamePrefix="talaash-select"
                  value={getSelected(familyTypeOptions, formData.familyType)}
                  onChange={(opt) => handleSelectChange("familyType", opt?.value)}
                />
              </div> */}

{/* <div className="col-md-12">
                <label>Preferred Personality Traits</label>
                <Select
                  isMulti
                  options={personalityOptions} classNamePrefix="talaash-select"
                  value={getMultiSelected(personalityOptions, formData.partnerPersonality)}
                  onChange={(opt) =>
                    handleSelectChange("partnerPersonality", opt.map((o) => o.value))
                  }
                />
              </div> */}

            </div>
          </div>
 

         
 

        
          {/* ABOUT PARTNER */}
          
          {/* <div className="pref-section-box">
            <textarea
              rows={4}
              placeholder="Write what qualities you are looking for…"
              value={formData.aboutPartner}
              onChange={(e) => handleSelectChange("aboutPartner", e.target.value)}
            ></textarea>
          </div> */}

          <div className="text-center mt-4">
            <button className="btn-primary">Save Partner Preferences →</button>
          </div>

        </form>
      </div>
    </section>

    <FooterTwo />


    </>


  );
}

export default PartnerPreferences;
